var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat_applet"},[_c('div',{staticClass:"t2"},[_vm._v("微信小程序")]),_c('div',{staticClass:"body"},[_c('img',{attrs:{"src":_vm.img}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }